import * as React from "react";
import { SVGProps } from "react";
const SvgSlider = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#slider_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.189 9.834a1 1 0 1 0-1.104-1.668c-2.726 1.803-5.275 4.02-7.623 6.63a1.853 1.853 0 0 0 .003 2.452 40.126 40.126 0 0 0 7.62 6.586 1 1 0 0 0 1.104-1.668A38.101 38.101 0 0 1 2.05 16.02c2.21-2.437 4.596-4.504 7.138-6.186h.001Zm13.623 12.332a.999.999 0 1 0 1.103 1.668c2.722-1.8 5.27-4.017 7.623-6.629a1.854 1.854 0 0 0-.003-2.452 40.161 40.161 0 0 0-7.62-6.587 1 1 0 0 0-1.104 1.668 38.14 38.14 0 0 1 7.138 6.147c-2.214 2.44-4.6 4.507-7.137 6.185Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="slider_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSlider;
